import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { APIManager } from '@flashvpn-io/web-core';
import { Subscription } from 'rxjs';

import { MenuService } from '../menu/menu.service';

@Component({
  selector: 'app-client-installation',
  templateUrl: './client-installation.component.html',
  styleUrls: ['./client-installation.component.css']
})
export class ClientInstallationComponent implements OnDestroy {
  @Input() deliveryIps: string[] = [];
  public clientInformation: ClientInformation | null = null;
  private platformSubscription: Subscription;
  public platform: string = '';
  public appDomain: string[] = [];
  constructor(
    private apiManager: APIManager,
    public menuService: MenuService
  ) {
    this.platformSubscription = this.menuService.currentPlatform$.subscribe(menu => {
      this.getClientInformation(menu);
      this.platform = this.menuService.getPlatformLabel();
    });
    this.getDomains();
  }

  getDomains() {
    this.apiManager.getDeliveryDomains("This value will be overwritten by the environment variable").subscribe((value) => {
      this.appDomain = value.app;
    });
  }


  ngOnDestroy(): void {
    if (this.platformSubscription) {
      this.platformSubscription.unsubscribe();
    }
  }

  getClientInformation(platform: string) {
    this.apiManager.getAppLinkByAppCenter(platform).subscribe((res) => {
      this.clientInformation = res as ClientInformation;
    });
  }

  onGuideClick() {
    // TODO: Implement guide click handler
  }

  onDownloadClick(option: number) {
    if (this.appDomain.length === 0) {
      window.open(this.clientInformation?.download_url, '_blank');
      return;
    }
    window.open(`https://${this.appDomain[option - 1]}:10086${this.clientInformation?.download_url}`, '_blank');

  }

  generateGuideUrl(ip: string, platform: string) {
    return `http://${ip}:9993/how-to-use-rubiz-on-${platform.toLowerCase()}`;
  }
}

export interface ClientInformation {
  download_url: string;
  platform: string;
  release_notes: string;
  short_version: string;
  uploaded_at: string;
  version: string;
}
